<div class="core-filter-select" [class.is-open]="isOpen" [class.is-error]="error" [class.core-filter-select--sm]="size === 'sm'" [style.--core-ui-dropdown-icon-color]="iconColor">
  <button type="button" cdkOverlayOrigin #origin="cdkOverlayOrigin" #originRef class="core-filter-select__control"
    [class.is-filled]="isFilled" [class.is-readonly]="readOnly" (pointerdown)="onControlPointerDown()"
    (click)="toggleDropdown()" (keydown)="onControlKeyDown($event)" [disabled]="disabled" [attr.aria-invalid]="error">
    <core-ui-icon *ngIf="iconLeft" class="core-filter-select__icon-left" [name]="iconLeft" size="lg"
      [color]="iconColor" aria-hidden="true"></core-ui-icon>
    <div class="core-filter-select__texts">
      <span *ngIf="label" class="core-filter-select__label">
        {{ label }}
      </span>

      <span #valueEl class="core-filter-select__value" [class.is-placeholder]="(
          (multiple ? currentMultiValues.length === 0 : !getSelectedOption())
          && !(isOpen && openDisplayText)
        )" [class.is-filled-text]="isFilled">
        <ng-container *ngIf="isOpen && openDisplayText; else normalValueTpl">
          {{ openDisplayText }}
        </ng-container>

        <ng-template #normalValueTpl>

          <ng-container *ngIf="!multiple">
            <ng-container *ngIf="getSelectedOption(); else placeholderTpl">
              <ng-container *ngIf="valueTpl; else defaultValueTpl" [ngTemplateOutlet]="valueTpl"
                [ngTemplateOutletContext]="{ $implicit: getSelectedOption() }">
              </ng-container>

              <ng-template #defaultValueTpl>
                {{ getSelectedLabel() }}
              </ng-template>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="multiple">
            <ng-container *ngIf="currentMultiValues.length > 0; else placeholderTpl">
              {{ displayText }}
            </ng-container>
          </ng-container>

          <ng-template #placeholderTpl>
            {{ placeholder }}
          </ng-template>
        </ng-template>
      </span>
    </div>

    <core-ui-icon *ngIf="iconRight" class="core-filter-select__icon-right" [name]="iconRight" size="lg"
      [color]="iconColor" aria-hidden="true"></core-ui-icon>
    <div class="core-filter-select__chevron" *ngIf="!hideChevron">
      <core-ui-icon name="chevron" [size]="sizeIcon" [direction]="isOpen ? 'up' : 'down'" [color]="iconColor"
        [extraClass]="'klab-sidebar__item-chevron'">
      </core-ui-icon>
    </div>
  </button>

  <div class="core-filter-select__dropdown" *ngIf="isOpen && !useOverlay" #panelEl [class.is-up]="openUp"
    [class.is-positioning]="!isPanelPositioned"
    [class.core-filter-select__dropdown--sm]="size === 'sm'"
    [style.max-height.px]="panelMaxHeight" (mousedown)="onPanelMouseDown()">
    <ng-container *ngTemplateOutlet="panelContent"></ng-container>
  </div>

  <ng-template cdkConnectedOverlay #connectedDrop="cdkConnectedOverlay" [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen && useOverlay" [cdkConnectedOverlayWidth]="overlayWidth"
    [cdkConnectedOverlayHasBackdrop]="false" [cdkConnectedOverlayScrollStrategy]="overlayScrollStrategy"
    [cdkConnectedOverlayPositions]="overlayPositions" [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8" [cdkConnectedOverlayPanelClass]="overlayPanelClass"
    (detach)="onOverlayDetach()">
    <div class="core-filter-select__dropdown core-filter-select__dropdown--overlay"
      [class.is-positioning]="!isPanelPositioned"
      [class.core-filter-select__dropdown--sm]="size === 'sm'"
      [style.max-height.px]="panelMaxHeight" (mousedown)="onPanelMouseDown()">
      <ng-container *ngTemplateOutlet="panelContent"></ng-container>
    </div>
  </ng-template>

  <ng-template #panelContent>
    <button *ngFor="let option of options; let i = index" type="button" class="core-filter-select__option"
      [ngClass]="{ 'core-filter-select__option--selected': isSelected(option), 'core-filter-select__option--active': i === activeOptionIndex }"
      (mouseenter)="onOptionMouseEnter(i)"
      (mousedown)="!readOnlyOptions && onSelect(option); $event.preventDefault()">
      <span *ngIf="multiple" class="core-filter-select__check">
        {{ isSelected(option) ? '✓' : '' }}
      </span>

      <ng-container *ngIf="optionTpl; else defaultOptionTpl" [ngTemplateOutlet]="optionTpl"
        [ngTemplateOutletContext]="{ $implicit: option, selected: isSelected(option) }"></ng-container>

      <ng-template #defaultOptionTpl>
        {{ getOptionLabel(option) }}
      </ng-template>
    </button>

    <div *ngIf="multiple && showApplyButton" class="core-filter-select__footer">
      <button type="button" (click)="clear()">Limpiar</button>
      <button type="button" (click)="apply()">Aplicar</button>
    </div>
  </ng-template>
</div>
